import React from 'react'

type ElementOnScreen = [React.MutableRefObject<null>, boolean]

function useElementOnScreen(
    options: IntersectionObserverInit = { threshold: 0.3 }
): ElementOnScreen {
    const elementRef = React.useRef(null)
    const [isVisible, setIsVisible] = React.useState(false)

    React.useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            const [entry] = entries
            setIsVisible(entry.isIntersecting)
            if (entry.isIntersecting) observer.unobserve(entry.target)
        }, options)

        const element = elementRef.current
        if (element) observer.observe(element)

        return () => observer.disconnect()
    }, [elementRef, options])

    return [elementRef, isVisible]
}

export { useElementOnScreen }
